import { memo } from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import classes from './GradientCta.module.scss';

interface Props {
  // 言語プレフィックス配下のパス（例: "about" / "interview"）
  to: string;
  text: string;
  className?: string;
}

export const GradientCta: FC<Props> = memo(function GradientCta({ to, text, className }) {
  const { i18n } = useTranslation();
  const langCode = i18n.language;

  return (
    <Link to={`/${langCode}/${to}`} className={`${classes.cta} ${className || ''}`}>
      <span className={classes.text}>{text}</span>
      <span className={classes.arrow}>→</span>
    </Link>
  );
});
